export default "__VITE_ASSET__e528842c__"